










import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class Slider extends Vue {

    public value = 0;

    @Watch('value')
    public onValueChanged() {
        window.console.log(`onValueChanged() ${this.value}`)
        const val = Number(this.value);
        const playbackSpeed = Math.pow(1.2, val);

        store.dispatch('MissionAnimation/UpdatePlaybackSpeed', playbackSpeed);
    }

}
